var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "font-size": "14px" } }, [
      _c(
        "div",
        { staticClass: "row mx-0 bg-primary text-white px-4 pt-4 pb-2" },
        [
          _c("div", { staticClass: "col-12 px-0" }, [
            _c("h3", [_vm._v("ログインしてたくさんの漫画をオトクに楽しもう")])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white p-2 border mb-3 row mx-0" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("h3", [_vm._v("①無料会員登録でもっと読める")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("span", [
            _c("strong", [_vm._v("79,000話")]),
            _vm._v("の"),
            _c("span", { staticClass: "text-ticket" }, [_vm._v("待つと無料")]),
            _vm._v("\n        漫画が読める！")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("img", {
              staticStyle: {
                width: "100%",
                "max-width": "400px",
                "margin-top": "20px"
              },
              attrs: {
                src:
                  "https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login1.png"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "small text-danger mb-3" }, [
            _vm._v(
              "\n        セールには会員限定で無料作品も豊富にあります\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white p-2 border mb-3 row mx-0" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("h3", [_vm._v("②チケットが貰える")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-6 mb-3 text-center",
            staticStyle: { "border-right": "1px solid #EEE" }
          },
          [
            _c("strong", { staticClass: "text-ticket" }, [
              _vm._v("作品専用チケット")
            ]),
            _vm._v("で複数の作品が1日1話ずつ読める\n      "),
            _c("img", {
              staticStyle: { width: "100%", "max-width": "400px" },
              attrs: {
                src:
                  "https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login4-3.png"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6 mb-3 text-center" }, [
          _vm._v("\n      1日3枚の"),
          _c("strong", { staticClass: "text-ticket" }, [
            _vm._v("ボーナスチケット")
          ]),
          _vm._v("で一気読みも可能\n      "),
          _c("img", {
            staticStyle: { width: "100%", "max-width": "250px" },
            attrs: {
              src:
                "https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login5-2.png"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white p-2 border mb-3 row mx-0" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("h3", [_vm._v("③本棚管理")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-6 text-center mb-3",
            staticStyle: { "border-right": "1px solid #EEE" }
          },
          [
            _vm._v("\n      どこまで読んだか色分けですぐ分かる\n      "),
            _c("img", {
              staticStyle: { width: "100%", "max-width": "400px" },
              attrs: {
                src:
                  "https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login2.png"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6 w-md-50 mb-3 text-center" }, [
          _vm._v("\n      以前読んでいた作品を本棚からすぐに探せる\n      "),
          _c("img", {
            staticStyle: { width: "100%", "max-width": "400px" },
            attrs: {
              src:
                "https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login3.png"
            }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }